import React from "react";
import { useTableContext } from "../../components/AdministrateTable";
import { NetworkStatusToggle } from "../../payors/components/NetworkStatusToggle";
import { useUpdatePermission } from "../../utils";
import { History } from "../../tools/sandbox/release/History";

export const LabPayorNetworkStatusActionCell = ({ labId, labName, ...row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const { payorId, payorName, payorLabSettingId, inNetwork } = row.original;
  const [canUpdate] = useUpdatePermission("PayorLabSetting", row.original.id);

  const handleChange = (msg) => {
    setMessage(msg);
    refresh();
  };

  const handleError = (msg) => {
    setError(msg);
    refresh();
  };

  return (
    <div className="d-flex align-items-center justify-content-between">
      {canUpdate && (
        <NetworkStatusToggle
          payorId={payorId}
          payorName={payorName}
          inNetwork={inNetwork}
          payorLabSettingId={payorLabSettingId}
          labId={labId}
          labName={labName}
          onChange={handleChange}
          onError={handleError}
          disabled={!canUpdate}
        />
      )}
      <History entityName="PayorLabSetting" subjectId={payorLabSettingId ?? "unspecified"} />
    </div>
  );
};
